module.exports = __webpack_public_path__ + "static/media/user_details.21ebf57d.PNG";